import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BrandLogo } from '@/components/common/BrandLogo';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { Icon } from '@/components/common/Icon';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { SafeHtml } from '@/components/common/SafeHtml';
import { Button } from '@/components/ui/button';
import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import { LEGAL_DOCUMENT_SLUGS } from '@/constants/legal';
import { useLegalDocumentQuery } from '@/hooks/useLegal';
import { LegalLinks } from '../LegalLinks';

function printDocument() {
  window.print();
}

export function LegalDocumentPage() {
  const { t } = useTranslation('legal');
  const { documentSlug } = useParams();
  const documentCode = documentSlug === undefined ? undefined : LEGAL_DOCUMENT_SLUGS[documentSlug];
  const documentQuery = useLegalDocumentQuery(documentCode);

  return (
    <div className="min-h-screen bg-zoooffwhite px-4 py-8">
      <div className="fixed top-4 right-4 z-50 print:hidden">
        <LanguageSwitcher />
      </div>
      <div className="max-w-3xl mx-auto">
        <div className="flex justify-center mb-6">
          <Link to={APPLICATION_ROUTES.login} aria-label={t('backToSignIn')}>
            <BrandLogo className="h-10 w-auto object-contain" />
          </Link>
        </div>
        <article className="bg-zoowhite border border-zooborder rounded-3xl shadow-sm p-6 md:p-10">
          {documentCode === undefined || documentQuery.isError ? (
            <p className="text-sm text-zoomuted text-center">{t('notFound')}</p>
          ) : documentQuery.data === undefined ? (
            <div className="py-10 flex justify-center">
              <LoadingSpinner className="w-6 h-6" />
            </div>
          ) : (
            <>
              <div className="flex items-start justify-between gap-4">
                <h1 className="text-2xl font-bold text-zooindigo">{documentQuery.data.title}</h1>
                <Button
                  type="button"
                  variant="outline"
                  size="small"
                  className="shrink-0 print:hidden"
                  onClick={printDocument}
                >
                  <Icon name="Printer" />
                  {t('printOrSave')}
                </Button>
              </div>
              <p className="text-xs text-zoomuted mt-1 mb-4">
                {t('version', { version: documentQuery.data.version })}
              </p>
              <SafeHtml html={documentQuery.data.bodyHtml} className="[&_h2]:mt-6 [&_h2]:mb-1" />
            </>
          )}
        </article>
        <LegalLinks className="mt-6 print:hidden" />
      </div>
    </div>
  );
}
